import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'help',
  setup(__props) {

onMounted(()=>{
    document.title="帮助";
})


const value1 = ref<string>();


return { __sfc: true,value1 }
}

})